import { NgModule } from '@angular/core';
import { SharedModule } from '~app/app/~shared/modules/shared.module';
import { ScreenListDatatableComponent } from './components/screen-list-datatable/screen-list-datatable.component';

const DECLARATIONS = [ScreenListDatatableComponent];

const MODULES = [SharedModule];

@NgModule({
  declarations: DECLARATIONS,
  imports: [...MODULES],
  exports: [...MODULES, ...DECLARATIONS],
  providers: []
})
export class ScreenModule {}
